import React, { useEffect } from 'react';
import { TitledContainer } from '../../../../components/TitledContainer/TitledContainer';
import { PaymentsOverviewContainer } from './PaymentsOverviewContainer';

interface Props {}

const PaymentsPage: React.FC<Props> = ({}) => {
  useEffect(() => {
    document.title = 'Logistics | Betalingen';
  });

  return (
    <TitledContainer title='Uitbetalingen'>
      <PaymentsOverviewContainer />
    </TitledContainer>
  );
};

export { PaymentsPage };
